/**
 * Collection Carousel Section
 */

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  const collectionCarousels = document.querySelectorAll('[data-section-type="collection-carousel"]');
  
  collectionCarousels.forEach(function(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const carouselEl = document.getElementById('collection-carousel-' + sectionId);
    
    if (carouselEl && typeof Swiper !== 'undefined') {
      // Get settings from data attributes
      const slidesPerView = carouselEl.getAttribute('data-slides-per-view') || 3.5;
      const spaceBetween = carouselEl.getAttribute('data-space-between') || 24;
      const speed = carouselEl.getAttribute('data-speed') || 600;
      const autoplay = carouselEl.getAttribute('data-autoplay') === 'true';
      const autoplayDelay = carouselEl.getAttribute('data-autoplay-delay') || 5000;
      const loop = carouselEl.getAttribute('data-loop') === 'true';
      const blockCount = carouselEl.querySelectorAll('.collection-carousel__item').length;
      
      new Swiper(carouselEl, {
        slidesPerView: parseInt(slidesPerView),
        spaceBetween: parseInt(spaceBetween),
        loop: loop,
        loopedSlides: loop ? parseInt(blockCount) : 0,
        autoplay: autoplay ? {
          delay: parseInt(autoplayDelay),
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        speed: parseInt(speed),
        navigation: {
          nextEl: carouselEl.parentElement.querySelector('.collection-carousel__nav-next'),
          prevEl: carouselEl.parentElement.querySelector('.collection-carousel__nav-prev'),
        },
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          640: {
            slidesPerView: 2.1,
            spaceBetween: parseInt(spaceBetween)
          },
          1024: {
            slidesPerView: parseInt(slidesPerView),
            spaceBetween: parseInt(spaceBetween)
          }
        }
      });
    }
  });
});
